<template>
    <div>
      <div v-clickoutside="hideReplyBtn" @click="inputFocus" class="my-reply" id="my-reply">
          <el-avatar class="header-img" :size="55" :src="myHeader"></el-avatar>
          <div class="reply-info" >
              <div
              tabindex="0"
              contenteditable="true"
              id="replyInput"
              spellcheck="false"
              placeholder="尊重是评论打动人心的入场卷"
              class="reply-input"
              @focus="showReplyBtn"
              @input="onDivInput($event)"
              >
              </div>
          </div>
          <div class="reply-btn-box" v-show="btnShow">
              <el-button class="reply-btn" style="float: right;margin-top:10px ;" size="medium" @click="sendComment" type="primary">发表评论</el-button>
          </div>
      </div>
      <div v-for="(item,i) in comments" :key="i" class="author-title reply-father">
          <el-avatar class="header-img" :size="50" :src="item.headImg"></el-avatar>
          <div class="author-info">
              <span class="author-name">{{item.name}}</span>
              <div class="talk-box">
                  <p>
                      <span class="reply">{{item.comment}}</span>
                  </p>
              </div>
              <span class="author-time">
              {{item.time}}
              <div class="icon-btn">
                  <!-- <span @click="showReplyInput(i,item.name,item.id)"><i class="iconfont el-icon-s-comment"></i>{{item.commentNum}}</span> -->
                  <!-- <i class="iconfont el-icon-caret-top"></i>{{item.like}} -->
                  <img class="iconfont" @click="toggleLike(item,i)" :src="'/static/images/'+(item.isLike?'newHeart2021Active.png':'commentLikeWhite.png')">{{item.like}}
                  <span @click="showReplyInput(i,item.name,item.id)" style="margin-left:10px;">回复</span>
              </div>
              </span>
          </div>
          <div class="reply-box">
              <div v-for="(reply,j) in item.reply" :key="j" class="author-title">
                  <el-avatar class="header-img" :size="40" :src="reply.fromHeadImg"></el-avatar>
                  <div class="author-info">
                      <span class="author-name">{{reply.from}}</span>
                     <div class="talk-box">
                          <p>
                            <span>回复 {{reply.to}}:</span>
                            <span class="reply">{{reply.comment}}</span>
                          </p>
                      </div>
                      <span class="author-time">
                      {{reply.time}}
                      <div class="icon-btn">
                          <!-- <span @click="showReplyInput(i,item.name,item.id)"><i class="iconfont el-icon-s-comment"></i>{{item.commentNum}}</span> -->
                          <!-- <i class="iconfont el-icon-caret-top"></i>{{item.like}} -->
                          <img class="iconfont" @click="toggleLike(item,i,j)" :src="'/static/images/'+(reply.isLike?'newHeart2021Active.png':'commentLikeWhite.png')">{{reply.like}}
                          <span @click="showReplyInput(i,item.name,item.id)" style="margin-left:10px;">回复</span>
                      </div>
                      </span>
                  </div>
                  <div class="reply-box">
                  </div>
              </div>
          </div>
          <div v-show="_inputShow(i)" class="my-reply my-comment-reply" id="my-comment-reply">
              <el-avatar class="header-img" :size="40" :src="myHeader"></el-avatar>
              <div class="reply-info">
                <div class="reply-input reply-comment-input" tabindex="0" contenteditable="true"
                spellcheck="false" placeholder="输入评论..." @input="onDivInput($event)"
                @blur="hidenReply()"></div>
              </div>
              <div class="reply-btn-box">
                <el-button class="reply-btn" style="float: right;margin-top: 10px;" size="medium" @click="sendCommentReply(i)" type="primary">发表评论</el-button>
              </div>
          </div>
      </div>
    </div>
</template>
<script>
const clickoutside = {
    // 初始化指令
    bind(el, binding, vnode) {
    function documentHandler(e) {
    // 这里判断点击的元素是否是本身，是本身，则返回
        if (el.contains(e.target)) {
            return false;
        }
    // 判断指令中是否绑定了函数
        if (binding.expression) {
            // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
            binding.value(e);
        }
    }
    // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
    el.vueClickOutside = documentHandler;
    document.addEventListener('click', documentHandler);
    },
    update() {},
    unbind(el, binding) {
    // 解除事件监听
    document.removeEventListener('click', el.vueClickOutside);
    delete el.vueClickOutside;
  },
};
export default {
    name:'ArticleComment',
    data(){
        return{
            btnShow: false,
            replyShow: false,
            index:'0',
            replyComment:'',
            myName:'Lana',
            myHeader:'https://dentbird.com/_next/image/?url=%2Fassets%2Fimages%2Fproducts%2FDoctor4x.webp&w=384&q=75',
            myId:19870621,
            to:'',
            toId:-1,
            comments:[
                {
                    name:'Lana',
                    id:19870621,
                    headImg:'/static/images/default.png',
                    comment:'我发布一张新专辑Norman Fucking Rockwell,大家快来听啊',
                    time:'2019年9月16日 18:43',
                    commentNum:2,
                    like:15,
                    isLike:false,
                    inputShow:false,
                    reply:[
                        {
                            from:'Taylor',
                            fromId:19891221,
                            fromHeadImg:'/static/images/home-mall111.jpg',
                            to:'Lana Del Rey',
                            toId:19870621,
                            comment:'我很喜欢你的新专辑！！',
                            time:'2019年9月16日 18:43',
                            commentNum:1,
                            like:10,
                            isLike:false,
                            inputShow:false
                        },
                        {
                            from:'Ariana',
                            fromId:1123,
                            fromHeadImg:'/static/images/home-mall222.png',
                            to:'Lana Del Rey',
                            toId:19870621,
                            comment:'别忘记宣传我们的合作单曲啊',
                            time:'2019年9月16日 18:43',
                            commentNum:0,
                            like:1,
                            isLike:false,
                            inputShow:false
                        }
                    ]
                },
                {
                    name:'Taylor',
                    id:19891221,
                    headImg:'/static/images/home-mall111.jpg',
                    comment:'我发行了我的新专辑Lover',
                    time:'2019年9月16日 18:43',
                    commentNum:1,
                    like:5,
                    isLike:false,
                    inputShow:false,
                    reply:[
                        {
                            from:'Lana',
                            fromId:19870621,
                            fromHeadImg:'/static/images/default.png',
                            to:'Taylor Swift',
                            toId:19891221,
                            comment:'新专辑和speak now 一样棒！',
                            time:'2019年9月16日 18:43',
                            commentNum:25,
                            like:5,
                            isLike:false,
                            inputShow:false
                        }
                    ]
                },
                {
                    name:'Steven',
                    id:20190830,
                    headImg:'/static/images/user-avatar.png',
                    comment:'Plz buy Norman Fucking Rockwell on everywhere',
                    time:'2019年9月16日 18:43',
                    commentNum:0,
                    like:3,
                    isLike:false,
                    inputShow:false,
                    reply:[]
                },
            ]
        }
    },
    directives: {clickoutside},
    methods: {
        inputFocus(){
            var replyInput = document.getElementById('replyInput');
            replyInput.style.padding= "15px 15px"
            replyInput.style.border ="1px solid #ccc"
            replyInput.focus()
        },
        showReplyBtn(){
            this.btnShow = true
            var myReply = document.getElementById('my-reply');
            myReply.style.height = '115px';
            replyInput.style.color= "#000"
        },
        hideReplyBtn(){
            this.btnShow = false
            replyInput.style.padding= "15px"
            replyInput.style.color= "#ccc"
            replyInput.style.border ="none"
            var myReply = document.getElementById('my-reply');
            myReply.style.height = '75px';
        },
        showReplyInput(i,name,id){
            this.comments[this.index].inputShow = false
            this.index =i
            this.comments[i].inputShow = true
            this.to = name
            this.toId = id
            var myCommentReply = document.getElementById('my-comment-reply');
            myCommentReply.style.height = '110px'
        },
        _inputShow(i){
            return this.comments[i].inputShow
        },
        sendComment(){
            if(!this.replyComment){
                 this.$message({
                    showClose: true,
                    type:'warning',
                    message:'评论不能为空'
                })
            }else{
                let a ={}
                let input =  document.getElementById('replyInput')
                let timeNow = new Date().getTime();
                let time= this.dateStr(timeNow);
                a.name= this.myName
                a.comment =this.replyComment
                a.headImg = this.myHeader
                a.time = time
                a.commentNum = 0
                a.like = 0
                this.comments.push(a)
                this.replyComment = ''
                input.innerHTML = '';

            }
        },
        sendCommentReply(i){
            if(!this.replyComment){
                 this.$message({
                    showClose: true,
                    type:'warning',
                    message:'评论不能为空'
                })
            }else{
                let a ={}
                let timeNow = new Date().getTime();
                let time= this.dateStr(timeNow);
                a.from= this.myName
                a.to = this.to
                a.fromHeadImg = this.myHeader
                a.comment =this.replyComment
                a.time = time
                a.commentNum = 0
                a.like = 0
                this.comments[i].reply.push(a)
                this.replyComment = ''
                document.getElementsByClassName("reply-comment-input")[i].innerHTML = ""
            }
        },
        onDivInput: function(e) {
            this.replyComment = e.target.innerHTML;
        },
        dateStr(date){
            //获取js 时间戳
            var time=new Date().getTime();
            //去掉 js 时间戳后三位，与php 时间戳保持一致
            time=parseInt((time-date)/1000);
            //存储转换值
            var s;
            if(time<60*10){//十分钟内
                return '刚刚';
            }else if((time<60*60)&&(time>=60*10)){
                //超过十分钟少于1小时
                s = Math.floor(time/60);
                return  s+"分钟前";
            }else if((time<60*60*24)&&(time>=60*60)){
                //超过1小时少于24小时
                s = Math.floor(time/60/60);
                return  s+"小时前";
            }else if((time<60*60*24*30)&&(time>=60*60*24)){
                //超过1天少于30天内
                s = Math.floor(time/60/60/24);
                return s+"天前";
            }else{
                //超过30天ddd
                var date= new Date(parseInt(date));
                return date.getFullYear()+"/"+(date.getMonth()+1)+"/"+date.getDate();
            }
        },
        hidenReply(){
          this.$nextTick(() => {
              let activeInput = document.querySelector('.reply-comment-input:focus');
              if (!activeInput) {
                  for (let i = 0; i < this.comments.length; i++) {
                    const replyContent = document.getElementsByClassName("reply-comment-input")[i].innerHTML.trim();
                    if(replyContent == ''){
                      this.comments[i].inputShow = false;
                    }
                  }
              }
          });
        },
        toggleLike(item,i,j){
          if(j!==undefined){
            console.log('log',i)
            console.log('log',this.comments[i])
            let replyItem = this.comments[i].reply[j];
            replyItem.isLike = !replyItem.isLike;
            replyItem.like = replyItem.isLike?replyItem.like+1:replyItem.like-1;
          }else{
            console.log('log',i,j)
            console.log('log',this.comments[i])
            item.isLike = !item.isLike;
            item.like = item.isLike ?item.like + 1 :item.like - 1;
          }
        }
    },
}
</script>
<style lang="scss" scoped>
.my-reply{
  padding: 10px;
  background-color: #F7F7F7;
  .header-img{
    display: inline-block;
    vertical-align: top;
  }
  .reply-info{
    display: inline-block;
    margin-left: 15px;
    width: 93%;
    height: 20px;
    @media screen and (max-width:1200px){
      width: 80%;
    }
    .reply-input{
      min-height: 20px;
      line-height: 22px;
      padding: 10px 10px;
      color: #ccc;
      background-color: #fff;
      border-radius: 5px;
      &:empty::before{
        content:attr(placeholder);
        color: #ccc;
      }
      &:focus::before{
        contnet:none;
      }
      &:focus{
        padding: 8px 8px;
        border: 1px solid #ccc;
        box-shadow: none;
        outline: none;
        color: #000;
      }
      .reply-btn-box{
        height: 45px;
        margin: 10px 0;
        .reply-btn{
          position: relative;
          float: right;
          margin-right: 15px;
        }
      }
    }
  }
}
.my-comment-reply{
  margin-left: 50px;
  background-color: #F7F7F7;
  .reply-input{
    width: flex;
  }
}
.author-titile:not(:last-child){
  border-bottom: 1px solid rgba(178, 186, 194, .3);
}
.author-title{
  padding: 10px 20px;
  .header-img{
    display:inline-block;
    vertical-align: top;
  }
  .author-info{
    display: inline-block;
    margin-left: 5px;
    width: 90%;
    height: auto;
    line-height: 20px;
    span{
      cursor: pointer;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .author-name{
      display: block;
      color: #000;
      margin-bottom: 5px;
      // font-size: 15px;
      // font-weight: bold;
    }
    .author-time{
      margin-top: 5px;
      display: block;
      font-size: 14px;
      color: #a4b0be;
    }
  }
  .iconfont{
    width: 16px;
    height: 16px;
    display: inline-block;
    vertical-align: middle;
    margin-right: 5px;
  }
  .icon-btn{
    display: inline-block;
    width: 30%;
    padding: 0 !important;
    margin-left: 15px;
    @media screen and (max-width:1200px){
      width: 20%;
      padding: 7px;
      span{
        cursor:pointer;
      }
    }
    .talk-box{
      margin: 0 50px;
      p{
        margin: 0;
      }
      .reply{
        font: size 16px;
        color: #000;
      }
    }
    .reply-box{
      margin: 10px 0 0 50px;
      background-color: #efefef;
    }
  }
}
</style>



// WEBPACK FOOTER //
// comment.vue?7e173e28